import { Component } from '@angular/core';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'y42-function-tag-renderer',
  templateUrl: './function-tag-renderer.component.html',
  styleUrls: ['./function-tag-renderer.component.scss'],
})
export class FunctionTagRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  logo?: IconName;

  async agInit(params: ICellRendererParams) {
    this.params = params;
    if (!this.params.node.group) {
      this.logo = this.params.data.tag_fontawesome_logo;
    } else {
      this.logo = this.params.node.allLeafChildren[0]?.data.tag_fontawesome_logo;
    }
  }

  // leave it for the abstract class
  refresh(): boolean {
    return false;
  }
}
